var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4137 6.2775L9 13.6912L4.96125 9.66375L3.375 11.25L9 16.875L18 7.875L16.4137 6.2775ZM11.25 0C5.04 0 0 5.04 0 11.25C0 17.46 5.04 22.5 11.25 22.5C17.46 22.5 22.5 17.46 22.5 11.25C22.5 5.04 17.46 0 11.25 0ZM11.25 20.25C6.2775 20.25 2.25 16.2225 2.25 11.25C2.25 6.2775 6.2775 2.25 11.25 2.25C16.2225 2.25 20.25 6.2775 20.25 11.25C20.25 16.2225 16.2225 20.25 11.25 20.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/VerifiedIcon.b016c8732fba2e2bed4480d923c8cb87.svg";
export { ForwardRef as ReactComponent };